import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { useSubscriptions } from "@/Common/context/subscriptions/Subscriptions";
import { ON_UPDATE_SYSTEM_SETTINGS_SUBSCRIPTION } from "@/Settings/api/SystemSettings/subscriptions";
import { ISystemSettings } from "@/Settings/types/Common/model";
import { useEffect } from "react";

export const useSystemSettingSubscription = (
	locationId: string,
	callBackFunction: (args: GraphqlQueryResponse<"onUpdateSystemSettings", ISystemSettings>["data"]) => void,
	identifier = ""
) => {
	const { addSubscription, getSubscription, deleteSubscription } = useSubscriptions();
	const systemSettingsSubscription = getSubscription(["systemSettingsSubscription", locationId, identifier]);
	systemSettingsSubscription?.setInvalidate(["systemSettingsSubscription", locationId, identifier]);

	useEffect(() => {
		addSubscription(
			["systemSettingsSubscription", locationId, identifier],
			[
				{
					context: "onUpdateSystemSettings",
					query: ON_UPDATE_SYSTEM_SETTINGS_SUBSCRIPTION,
					variables: {
						locationId,
					},
				},
			],
			true
		);

		return () => {
			deleteSubscription(["systemSettingsSubscription", locationId, identifier]);
		};
	}, [locationId]);

	systemSettingsSubscription?.subscriptions?.onUpdateSystemSettings?.setCallback(callBackFunction);
};
